// startup
// Load entry module
__webpack_require__("./node_modules/babel-polyfill/lib/index.js");
__webpack_require__("./assets/src/js/main.js");
// This entry module used 'exports' so it can't be inlined
__webpack_require__("./assets/src/scss/main.scss");
